import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

interface ActiveFilter {
  category: string;
  value: string;
}

@Component({
  selector: 'app-active-filters',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './active-filters.component.html',
  styleUrls: ['./active-filters.component.scss']
})
export class ActiveFiltersComponent {
  @Input() filters: ActiveFilter[] = [];
  @Input() isOpen: boolean = false;
  @Output() removeFilter = new EventEmitter<ActiveFilter>();
  @Output() toggleOpen = new EventEmitter<void>();

  onRemoveFilter(filter: ActiveFilter): void {
    this.removeFilter.emit(filter);
  }

  onToggle(): void {
    this.toggleOpen.emit();
  }
}
